import { Component } from 'react';
import PropTypes from 'prop-types';
import MainController from '../controllers/MainController';

export default class ScreenDetection extends Component {
  static propTypes = {
    mobileScreen: PropTypes.object,
    desktopScreen: PropTypes.object,
  };

  handleResize = () => {
    this.setState({ rerender: true });
  };

  componentDidMount () {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize);
  }

  render () {
    const { mobileScreen, desktopScreen } = this.props;

    if (MainController.showMobileVersion()) {
      return mobileScreen;
    }
    return desktopScreen;
  }
}



// WEBPACK FOOTER //
// ./src/components/ScreenDetection.js